:host{display:flex;height:100%;width:100%;background-color:#e9e9e9;flex-direction:column;gap:2px}
/*# sourceMappingURL=shape-list.component.css.map */
